import BaseService from './base';

export interface LiteratureViewModel {
  id?: any;
  title?: string;
  author?: string;
  publicDate?: string;
  content?: string;
  category?: string;
}


export class LiteratureService extends BaseService<LiteratureViewModel> {
  protected serviceApi: string = 'Literature';

  get NewModel(): LiteratureViewModel {
    return {
      title: '',
    };
  }
}
